"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataGrid = exports.DEFAULT_COLUMN_AMOUNT = void 0;
var pdfTheme_1 = require("../pdfTheme");
exports.DEFAULT_COLUMN_AMOUNT = 2;
var DataGrid = /** @class */ (function () {
    function DataGrid(entries, columnAmount) {
        if (columnAmount === void 0) { columnAmount = exports.DEFAULT_COLUMN_AMOUNT; }
        this.entries = entries;
        this.columnAmount = columnAmount;
    }
    DataGrid.prototype.exportContent = function () {
        var rows = [];
        for (var i = 0; i < this.entries.length; i += this.columnAmount) {
            // We fill this array with empty strings to pad out the table render
            var row = Array(this.columnAmount).fill('');
            for (var j = 0; j < this.columnAmount; j++) {
                var index = i + j;
                if (index < this.entries.length) {
                    var _a = this.entries[index], title = _a[0], value = _a[1];
                    row[j] = {
                        columnGap: pdfTheme_1.pdfTheme.spacing.default,
                        columns: [
                            {
                                text: "".concat(title, ":"),
                                style: ['cellTitle'],
                                width: 'auto'
                            }, {
                                text: value,
                                style: ['cellValue']
                            }
                        ]
                    };
                }
            }
            rows.push(row);
        }
        return {
            layout: 'noBorders',
            table: {
                // If there are no rows, then we need an empty 2d array to successfully render the table
                body: rows.length ? rows : [[]]
            },
            style: ['dataGrid']
        };
    };
    DataGrid.prototype.exportStyles = function () {
        return {
            dataGrid: {
                fontSize: 12,
                marginBottom: pdfTheme_1.DEFAULT_COMPONENT_SPACING,
                marginLeft: pdfTheme_1.DEFAULT_COMPONENT_SPACING,
                marginRight: pdfTheme_1.DEFAULT_COMPONENT_SPACING
            },
            cellTitle: {
                bold: true,
                fontSize: 12
            },
            cellValue: {
                fontSize: 10,
                marginTop: 2
            }
        };
    };
    return DataGrid;
}());
exports.DataGrid = DataGrid;
//# sourceMappingURL=DataGrid.js.map